export default "__VITE_ASSET__Cn$Ll0Km__"